/**
 * The embedded build: the same game, served inside someone else's page.
 *
 * itch.io runs an HTML5 project in an iframe on html.itch.zone. Two things
 * break there and neither is worth pretending otherwise about:
 *
 *   Google's sign-in cannot come back to an iframe on a foreign origin, so
 *   anything that needs an account is unreachable. That is Quick Match and
 *   Create Room. Solo, the Daily and joining a room by code all work, because
 *   none of them asks who you are.
 *
 *   A service worker cannot claim a scope it does not own, so registration
 *   fails. It is only a cache, so the build simply does not ask.
 *
 * Rather than leave a door that cannot open, the 1v1 cards hand the player to
 * the real site, where the account exists and the install link is one tap away.
 */
export const IS_EMBED = import.meta.env.VITE_EMBED === '1';

export const FULL_APP_URL = 'https://wot.aimtech.ai/?utm_source=itch&utm_medium=embed';

/** Open the real site in a new tab. The embed keeps playing behind it. */
export function leaveToFullApp(): void {
  window.open(FULL_APP_URL, '_blank', 'noopener');
}
